import { StrictMode, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { initDarkMode, useTheme } from './hooks/useTheme';
import { ConfirmProvider } from './components/ConfirmDialog';
import { usePlatformName } from './hooks/useBranding';
import './styles/globals.css';

initDarkMode();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function ThemeBootstrap() {
  useTheme();
  return null;
}

/** Keeps document.title in sync with the admin-configured platform name
 *  (Platform → Genel Ayarlar). Falls back to "CMS Hub" until the public
 *  branding endpoint resolves. */
function DocumentTitleBootstrap() {
  const name = usePlatformName();
  useEffect(() => {
    document.title = name;
  }, [name]);
  return null;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ConfirmProvider>
        <ThemeBootstrap />
        <DocumentTitleBootstrap />
        <App />
      </ConfirmProvider>
    </QueryClientProvider>
  </StrictMode>,
);
